import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { Sidebar } from "../components/navigation/Sidebar";
import { Header } from "../components/navigation/Header";
import { useUiStore } from "../stores/ui.store";
import { usePushSubscribe } from "../hooks/use-push-subscribe";
import { cn, initColorThemeFromStorage, TooltipProvider } from "@cliently/ui";

const isPlannerRoute = (pathname: string) =>
  /^\/programs\/[^/]+\/planner$/.test(pathname);

export const CoachLayout = () => {
  const sidebarOpen = useUiStore((s) => s.sidebarOpen);
  const plannerFocusMode = useUiStore((s) => s.plannerFocusMode);
  const location = useLocation();
  const onPlanner = isPlannerRoute(location.pathname);
  const immersivePlanner = onPlanner || plannerFocusMode;
  usePushSubscribe(true);

  useLayoutEffect(() => {
    initColorThemeFromStorage();
  }, []);

  return (
    <TooltipProvider delayDuration={200}>
      <a
        href="#main-content"
        className="bg-primary text-primary-foreground sr-only z-50 rounded-md px-3 py-2 focus:not-sr-only focus:absolute focus:left-2 focus:top-2"
      >
        Aller au contenu principal
      </a>
      <div className="flex h-screen overflow-hidden">
        {!plannerFocusMode ? <Sidebar /> : null}
        <div
          className={cn(
            "flex min-w-0 flex-1 flex-col overflow-hidden transition-all duration-300",
            plannerFocusMode
              ? "md:ml-0"
              : sidebarOpen
                ? "md:ml-64"
                : "md:ml-16",
          )}
        >
          {!plannerFocusMode ? <Header /> : null}
          <main
            id="main-content"
            tabIndex={-1}
            className={cn(
              "min-w-0 flex-1 focus:outline-none",
              immersivePlanner
                ? "overflow-hidden"
                : "overflow-y-auto overflow-x-hidden",
            )}
          >
            <div
              className={cn(
                "mx-auto w-full min-w-0",
                immersivePlanner
                  ? "flex h-full max-w-none flex-col px-0 py-0"
                  : "max-w-[1440px] px-4 py-4 md:px-6 md:py-6",
              )}
            >
              <Outlet />
            </div>
          </main>
        </div>
      </div>
    </TooltipProvider>
  );
};
